export default __webpack_public_path__ + "static/media/blog-hillside-retaining-003.0af9f0fd.jpg";